import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ProjectService} from '../../services';
import {ProjectDetails} from '../../models';
import {defer, from, Observable} from "rxjs";

@Component({
    selector: 'app-page-project-details',
    templateUrl: './page-project-details.component.html',
    styleUrls: ['./page-project-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageProjectDetailsComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private projectService = inject(ProjectService);

    public projectId: number;
    public project$: Observable<ProjectDetails>;

    async ngOnInit() {
        this.projectId = parseInt(this.route.snapshot.paramMap.get('projectId'), 10);
        this.project$ = defer(() => from(this.projectService.getProjectDetails(this.projectId)));
    }
}
